export const ActionTypes = {
  FETCH_CMSPAGE_DATA_PROGRESS: 'cmspage/fetch_cmspage_progress',
  FETCH_CMSPAGE_DATA_SUCCESS: 'cmspage/fetch_cmspage_success',
  FETCH_CMSPAGE_DATA_FAILED: 'cmspage/fetch_cmspage_failed',
  FETCH_CMSPAGE_DATA_NOT_FOUND: 'cmspage/fetch_cmspage_data_not_found',
};
